import React from 'react';

import { useAppSelector } from '@/store';
import { noticeStore } from '@/store/notice';
import { Presentation } from '../Presentation';

export const NoticeContainer: React.FC = () => {
  const notices = useAppSelector(noticeStore.selectors.noticesSelector);

  const childProps = {
    notices,
  };
  return <Presentation {...childProps} />;
};
